import React, { FC } from "react";
import { Alert } from "antd";
import { AlertError, MoreDetailsInfo } from "../../../interfaces/errorType";
import { LogWebhookRequest } from "../../../../documentSet/interfaces/documentSet";
import "./ExportFailedWithMessageAlert.scss";
import AlertIconRenderer from "./AlertIconRenderer";
import ErrorDetailsSection from "./ErrorDetailsSection";
import useMeasure from "react-use-measure";

type MeasureRef = ReturnType<typeof useMeasure>[0];

type Props = {
  errorMessageObject: AlertError;
  latestLogWebhookRequest: LogWebhookRequest;
  moreDetailsInfo: MoreDetailsInfo;
  containerRef: MeasureRef;
};

const ExportFailedWithMessageAlert: FC<Props> = ({
  errorMessageObject,
  latestLogWebhookRequest,
  moreDetailsInfo,
  containerRef,
}) => {
  return (
    <div ref={containerRef}>
      <Alert
        className="error__alert-warning"
        type="error"
        title={
          <div className="error-title-container">
            <AlertIconRenderer
              type={latestLogWebhookRequest.responseBody?.type}
            />
            {errorMessageObject.title}
          </div>
        }
        description={
          <div>
            <div className="error-description">
              {errorMessageObject.message}
            </div>
            <ErrorDetailsSection moreDetailsInfo={moreDetailsInfo} />
          </div>
        }
      />
    </div>
  );
};

export default ExportFailedWithMessageAlert;
